module.exports = __webpack_public_path__ + "img/c6.4c41f083.png";